export namespace TransportUnitsOfMeasure {
  export type LengthUnits = 'FT' | 'M' | 'MILE' | 'NM';
  export const LengthUnits = {
    FT: 'FT' as LengthUnits,
    M: 'M' as LengthUnits,
    MILE: 'MILE' as LengthUnits,
    NM: 'NM' as LengthUnits
  };
}
